export default __webpack_public_path__ + "static/media/challengemonitor-light-mode.f3e82be2.svg";